<div class="circle-number-label">
  {{ value }}
</div>
